import { Injectable } from "@angular/core";
// export class PrductQueryModel{

// }



@Injectable()
export class PaginationModel {
    pageNumber: number = 0;
    recordCount: number = 0;
    totalCount: number = 0;
    totalPages: number = 0;
    searchKeyword:string = '';
    sortBy:string = '';
    orderBy:string = 'DESC';  
  }